import React,{useRef} from 'react';
import {useDispatch} from 'react-redux';
import bg from '../../../images/about.jpg';

const PopupAbout = ({show}) => {
  const setApp = useDispatch();
  const popupDefaultRef = useRef();

  return (
    <>
      {
        !show ? null : (
          <div className="popup-child" style={{display:`${show === 'About' ? '' : 'none'}`,opacity:`${show ? 1 : 0}`}}>
            <div className="popup-image-head" style={{background:`#000 url(${bg}) center center`,backgroundSize:'cover'}}>
              <div/>
              <section>
                <h6>About the WILDMEAT<br/>Database Explorer</h6>
                <small>Header photo: © Unsplash</small>
              </section>
            </div>
            <div className="popup-child-text">
              <h4>
                Aim of the WILDMEAT Use Database
              </h4>
              <p>
                The aim of the WILDMEAT database is to ensure that efforts to sustainably govern and manage wild meat resources are based on the best available evidence, by providing open access to all currently available data on wildmeat hunting offtakes, consumption and sales.
              </p>
              <p>
                Hundreds of studies over the last few decades have documented the use of wild meat by hunters, rural communities, traders and town and city dwellers around the world. While these studies have given us valuable insights into the drivers, uses and users of wild meat, taken on their own they provide only localised snapshots. However, combined they can provide a powerful evidence base for policy makers, practitioners, researchers, and civil society.
              </p>
              <p>
                The WILDMEAT database holds data on wild meat consumption, hunting offtakes and market sales within one database and in one standardised format. This allows data from across different sites and studies to be combined and compared, to provide a holistic understanding of the volumes, characteristics, and correlates of wildmeat use across space and time. When data is available over time from the same site, the database can also be used to track changes in wildmeat harvest characteristics and use. When used as part of a monitoring and evaluation strategy, these time-series datasets can be used to evaluate the effectiveness of wildmeat management and policy interventions.
              </p>
              <p>
                Please note that to keep site locations anonymous, site locations on this data explorer are 'jittered' to within 40km of the real location. Site locations in downloaded data provided at the resolution of the smallest national admininstrative unit.
              </p>
              {/* <p>
              In many countries, at least some, if not most, hunting activity is illegal. Therefore, all individual, household and site names are kept anonymous in the WILDMEAT database, and site locations are provided at the resolution of the smallest national administrative unit, to ensure that the exact settlement or user cannot be identified. For further information on WILDMEAT Database ethics protocols, please refer to the <a href="#" onClick={event => {
                event.preventDefault();
                setApp({type:'_POPUP',payload:['popup','How to use the database']});
              }}>WILDMEAT Database User Guide</a>.
              </p> */}

              <h5>What data does the WILDMEAT database hold?</h5>
              <p>The WILDMEAT database holds three different types of data:</p>
              <ul className="ul-popup">
                <li><b>Hunting offtakes</b><br/>I.e. the number of individual animals harvested by hunters over a given period of time.</li>
                <li><b>Consumption</b><br/>I.e. the quantity of animal biomass consumed by individuals or within households over a given period of time.</li>
                <li><b>Market sales</b><br/>I.e. data on the price and number of individual animals, or pieces thereof, on offer at wild meat markets over a given period of time.</li>
              </ul>
            </div>
          </div>
        )
      }
    </>
  )
}
export default PopupAbout
